import Milestone from "../../entities/milestone";

/**
 * Milestone actions
 *
 * Call order:
 *
 * MILESTONE_SAVE_QUEUE:	adds the item to the save queue
 * --> MILESTONE_SAVE:	modifies the state
 * --> MILESTONE_SAVE_SUCCESS: if all went well
 * --> MILESTONE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail MILESTONE_SAVE_QUEUE is during the call to MILESTONE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const MILESTONE_FETCH_ONE_QUEUE: any = 'MILESTONE_FETCH_ONE_QUEUE';
export const MILESTONE_FETCH_SUCCESS: any = 'MILESTONE_FETCH_SUCCESS';
export const MILESTONE_FETCH_FAILURE: any = 'MILESTONE_FETCH_FAILURE';
export const MILESTONE_FETCH_ONE_SUCCESS: any = 'MILESTONE_FETCH_ONE_SUCCESS';
export const MILESTONE_FETCH_ONE_FAILURE: any = 'MILESTONE_FETCH_ONE_FAILURE';

export const MILESTONE_SAVE: any = 'MILESTONE_SAVE';
export const MILESTONE_SAVE_QUEUE: any = 'MILESTONE_SAVE_QUEUE';
export const MILESTONE_SAVE_SUCCESS: any = 'MILESTONE_SAVE_SUCCESS';
export const MILESTONE_SAVE_FAILURE: any = 'MILESTONE_SAVE_FAILURE';

export const MILESTONE_SAVE_MANY: any = 'MILESTONE_SAVE_MANY';
export const MILESTONE_SAVE_MANY_QUEUE: any = 'MILESTONE_SAVE_MANY_QUEUE';
export const MILESTONE_SAVE_MANY_SUCCESS: any = 'MILESTONE_SAVE_MANY_SUCCESS';
export const MILESTONE_SAVE_MANY_FAILURE: any = 'MILESTONE_SAVE_MANY_FAILURE';

export const MILESTONE_REMOVE: any = 'MILESTONE_REMOVE';
export const MILESTONE_REMOVE_QUEUE: any = 'MILESTONE_REMOVE_QUEUE';
export const MILESTONE_REMOVE_SUCCESS: any = 'MILESTONE_REMOVE_SUCCESS';
export const MILESTONE_REMOVE_FAILURE: any = 'MILESTONE_REMOVE_FAILURE';

export const MILESTONE_RESTORE: any = 'MILESTONE_RESTORE';
export const MILESTONE_RESTORE_QUEUE: any = 'MILESTONE_RESTORE_QUEUE';
export const MILESTONE_RESTORE_SUCCESS: any = 'MILESTONE_RESTORE_SUCCESS';
export const MILESTONE_RESTORE_FAILURE: any = 'MILESTONE_RESTORE_FAILURE';

export const MILESTONE_RESTORE_MANY: any = 'MILESTONE_RESTORE_MANY';
export const MILESTONE_REMOVE_MANY: any = 'MILESTONE_REMOVE_MANY';

/* Fetch actions */
export const fetchMilestoneSuccess = (milestones: Milestone[], partial: boolean, lastFetch: number) => ({type: MILESTONE_FETCH_SUCCESS, milestones, partial, lastFetch});
export const fetchMilestoneFailure = (err: any) => {
		console.error('MilestoneAction: fetchMilestoneFailure', err);
		return {type: MILESTONE_FETCH_FAILURE, err};
};
export const fetchOneMilestoneQueue = (milestoneId: string) => ({type: MILESTONE_FETCH_ONE_QUEUE, milestoneId});
export const fetchOneMilestoneSuccess = (milestone: Milestone) => ({type: MILESTONE_FETCH_ONE_SUCCESS, milestone});
export const fetchOneMilestoneFailure = (id: string, err: any) => {
		console.error('MilestoneAction: fetchOneMilestoneFailure', err);
		return {type: MILESTONE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveMilestone = (milestone: Milestone) => {
    // console.debug('⮂ MILESTONE_SAVE action', milestone?.id);
    return {type: MILESTONE_SAVE, milestone};
}
export const saveMilestoneQueue = (milestone: Milestone) => {
    // console.debug('⮂ MILESTONE_SAVE_QUEUE action', milestone?.id);
    return {type: MILESTONE_SAVE_QUEUE, milestone};
}
export const saveMilestoneSuccess = (milestone: Milestone) => {
    // console.debug('⮂ MILESTONE_SAVE_SUCCESS action', milestone?.id);
    return {type: MILESTONE_SAVE_SUCCESS, milestone};
}
export const saveMilestoneFailure = (milestone: Milestone, status: number, message: string) => {
    console.warn(`⮂ MILESTONE_SAVE_FAILURE error saving milestone: HTTP ${status}: ${message}`, milestone?.id);
    return {type: MILESTONE_SAVE_FAILURE, milestone, status, message};
};

/* SaveMany actions */
export const saveManyMilestones = (milestones: Milestone[]) => {
    // console.debug('⮂ MILESTONE_SAVE_MANY action', milestones?.map(milestone => milestone?.id).join(','));
    return {type: MILESTONE_SAVE_MANY, milestones};
}
export const saveManyMilestonesQueue = (milestones: Milestone[]) => {
    // console.debug('⮂ MILESTONE_SAVE_MANY_QUEUE action', milestones?.map(milestone => milestone.id).join(','));
    return {type: MILESTONE_SAVE_MANY_QUEUE, milestones};
}

export const saveManyMilestonesSuccess = (milestones: Milestone[]) => {
    // console.debug('⮂ MILESTONE_SAVE_MANY_SUCCESS action', milestones?.map(milestone => milestone.id).join(','));
    return {type: MILESTONE_SAVE_MANY_SUCCESS, milestones};
}
export const saveManyMilestonesFailure = (milestones: Milestone[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_MILESTONES_FAILURE Error saving milestones: HTTP ${status}: ${message}`, milestones?.map(milestone => milestone.id).join(','));
		return {type: MILESTONE_SAVE_MANY_FAILURE, milestones, status, message};
};

/* Remove actions */
export const removeMilestone = (milestone: Milestone) => ({ type: MILESTONE_REMOVE, milestone });
export const removeMilestoneQueue = (milestone: Milestone) => ({ type: MILESTONE_REMOVE_QUEUE, milestone });
export const removeMilestoneSuccess = (milestone: Milestone) => ({ type: MILESTONE_REMOVE_SUCCESS, milestone });
export const removeMilestoneFailure = (milestone: Milestone, status: number, message: string) => {
	console.error(`Redux: removeMilestoneFailure Error removing milestone: HTTP ${status}: ${message}`);
	return ({ type: MILESTONE_REMOVE_FAILURE, milestone, status, message });
};

/* Restore actions */
export const restoreMilestone = (milestone: Milestone) => ({ type: MILESTONE_RESTORE, milestone });
export const restoreMilestoneQueue = (milestone: Milestone) => ({ type: MILESTONE_RESTORE_QUEUE, milestone });
export const restoreMilestoneSuccess = (milestone: Milestone) => ({ type: MILESTONE_RESTORE_SUCCESS, milestone });
export const restoreMilestoneFailure = (milestone: Milestone, status: number, message: string) => {
	console.error(`Redux: restoreMilestoneFailure Error restoring milestone: HTTP ${status}: ${message}`);
	return ({ type: MILESTONE_RESTORE_FAILURE, milestone, status, message });
};

/* RestoreMany actions */
export const restoreManyMilestones = (milestones: Milestone[]) => ({ type: MILESTONE_RESTORE_MANY, milestones });

/* RemoveMany actions */
export const removeManyMilestones = (milestones: Milestone[]) => ({ type: MILESTONE_REMOVE_MANY, milestones });